import { render, staticRenderFns } from "./BoottomTab.vue?vue&type=template&id=1566f2d6&scoped=true"
import script from "./BoottomTab.vue?vue&type=script&lang=js"
export * from "./BoottomTab.vue?vue&type=script&lang=js"
import style0 from "./BoottomTab.vue?vue&type=style&index=0&id=1566f2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566f2d6",
  null
  
)

export default component.exports